import { Box } from 'src/components/Box';
import { Stack } from 'src/components/Stack';

import { UserContent } from './UserContent';
import { CheckinBlockerContentProps } from './_types';

export type { CheckinBlockerContentProps } from './_types';

/**
 * Shared blocking-reason body used by both the CheckinBlockerDialog (React)
 * and future fullscreen/iframe pages (embedded in Ember).
 *
 * This component is intentionally presentation-only — keep host-specific
 * chrome (dialog padding, page layout, scroll wrappers) in the consumer.
 */
export function CheckinBlockerContent({
  users,
  actions,
  inlineActions = false,
  showUserDetails = false,
}: CheckinBlockerContentProps) {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        width: '100%',
      }}
    >
      <Stack alignItems="center" spacing={3} sx={{ pb: 2, pt: 1, px: 3 }}>
        <UserContent
          users={users}
          actions={actions}
          inlineActions={inlineActions}
          showUserDetails={showUserDetails}
        />
      </Stack>
    </Box>
  );
}
